import TransactionsSteps from '../transactions/steps'
import RecurringSteps from '../recurring/steps'
import VaultSteps from '../vault/steps'
import VaultFinancialSteps from '../vaultFinancial/steps'
import MCPSteps from '../mcp/steps'
import ThreeDSTwoSteps from '../3DS2/steps'
import MCOSteps from '../checkout/steps'

export const FEATURES = {
    basicTransactionSet: {
        id: 'basic_transactions',
        name: 'Basic Transaction Set',
        steps: TransactionsSteps
    },
    vault: {
        id: 'vault_administrative',
        name: 'Vault Administrative Transactions',
        steps: VaultSteps
    },
    vaultFinancial: {
        id: 'vault_financial',
        name: 'Vault Financial Transactions',
        steps: VaultFinancialSteps
    },
    recurringBilling: {
        id: 'recurring_billing',
        name: 'Recurring Billing',
        steps: RecurringSteps
    },
    threeDSTwo: {
        id: '3ds2',
        name: '3D Secure 2.0',
        steps: ThreeDSTwoSteps
    },
    mcp: {
        id: 'mcp',
        name: 'Multi-Currency Pricing (MCP)',
        steps: MCPSteps
    },
    mco: {
        id: 'checkout',
        name: 'Moneris Checkout (MCO)',
        steps: MCOSteps
    }
}